// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;

class TransfersAgendaTableHeader extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <OKTableRow asHeader={true}>
                <OKTableCell asHeader={true}>
                    <span></span>
                </OKTableCell>
                <OKTableCell asHeader={true}>
                    <FormattedText value="transfersAgenda-aliasColumnHeader" />
                </OKTableCell>
                <OKTableCell asHeader={true}>
                    <FormattedText value="transfersAgenda-accountColumnHeader" />
                </OKTableCell>
                <OKTableCell asHeader={true}>
                    <FormattedText value="transfersAgenda-currencyColumnHeader" />
                </OKTableCell>
                <OKTableCell asHeader={true}>
                    <FormattedText value="transfersAgenda-countryColumnHeader" />
                </OKTableCell>
                <OKTableCell asHeader={true}>
                    <span></span>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

module.exports = TransfersAgendaTableHeader;
